const responsiveObj = {
  smallMobile: {
    breakpoint: { max: 6000, min: 10 },
    partialVisibilityGutter: -1,
    items: 1,
  },
};

export { responsiveObj as default };
